<template>
  <div class="w-full px-160px  page flex flex-col">
    <div class="w-full flex bg-white flex-1" v-loading="loading" style="background-color:#ffffff">
      <div class="flex-1 overflow-y-auto px-20px py-25px" style="border-right: 1px solid #f4e9ff;">
        <!-- <div class="pb-15px flex" style="border-bottom: 1px solid #f4e9ff">
          <span class="flex-1 text-black text-27px font-bold">
            {{ modelDetail.project_name_zh }}介绍
          </span>
          <img src="@/assets/images/model/edit.png" class="w-21px h-21px" />
        </div> -->
        <div class="mt-20px markdown-body" v-html="toMarkdown(modelDetail.content)"></div>
        <el-divider class="phoneshow"></el-divider>
        <div class="mt-0.1rem phoneshow" >
          <div class="text-21px font-bold text-black pb-15px">关联模型</div>
        <template v-if="correlationModels.length > 0">
          <div v-for="item in correlationModels" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{
      item.project_name_zh  
    }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goModelDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何模型... </template>

        <div class="text-21px font-bold text-black pb-15px mt-30px">
          关联数据集
        </div>
        <template v-if="correlationDatasets.length > 0">
          <div v-for="item in correlationDatasets" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{
      item.project_name_zh
    }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goDatasetDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何数据集... </template>
        <div class="text-21px font-bold text-black pb-15px mt-30px">
          关联体验
        </div>
        <template v-if="correlationSpaces.length > 0">
          <div v-for="item in correlationSpaces" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{ item.serving_name_zh }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goSpacesDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何体验... </template>
     
        </div>
      </div>

      <div class="w-363px px-20px py-25px pcshow">
        <div class="text-21px font-bold text-black pb-15px">关联模型</div>
        <template v-if="correlationModels.length > 0">
          <div v-for="item in correlationModels" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{
      item.project_name_zh
    }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goModelDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何模型... </template>

        <div class="text-21px font-bold text-black pb-15px mt-30px">
          关联数据集
        </div>
        <template v-if="correlationDatasets.length > 0">
          <div v-for="item in correlationDatasets" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{
      item.project_name_zh
    }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goDatasetDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何数据集... </template>
        <div class="text-21px font-bold text-black pb-15px mt-30px">
          关联体验
        </div>
        <template v-if="correlationSpaces.length > 0">
          <div v-for="item in correlationSpaces" :key="item.value" class="flex items-center mb-10px text-16px" v-if="item.is_show_project==1">
            <span class="flex-1 truncate text-default">{{ item.serving_name_zh }}</span>
            <el-button class="ml-3px p-0" type="text" @click="goSpacesDetail(item)">详情</el-button>
          </div>
        </template>
        <template v-else> 当前模型暂未关联任何体验... </template>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import path from '@/api/path'
import { marked } from 'marked'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.css'
import Footer from '@/components/layout/footer.vue'

marked.setOptions({
  renderer: new marked.Renderer(),
  highlight: function (code) {
    return hljs.highlightAuto(code).value
  },
  gfm: true, //默认为true。 允许 Git Hub标准的markdown.
  tables: true, //默认为true。 允许支持表格语法。该选项要求 gfm 为true。
  breaks: false, //默认为false。 允许回车换行。该选项要求 gfm 为true。
  pedantic: false, //默认为false。 尽可能地兼容 markdown.pl的晦涩部分。不纠正原始模型任何的不良行为和错误。
  sanitize: false, //对输出进行过滤（清理）
  smartLists: false,
  smartypants: true, //使用更为时髦的标点，比如在引用语法中加入破折号。
  langPrefix: 'hljs language-'
})

export default {
  components: { Footer },
  props: { data: {} },
  data() {
    return {
      modelDetail: {},
      correlationModels: [],
      correlationDatasets: [],
      correlationSpaces: [],
      loading1: false,
      loading2: false
    }
  },
  computed: {
    loading() {
      return this.loading1 && this.loading2
    }
  },
  created() {
    this.modelDetail = this.data
    this.getCorrelationModels()
    this.getCorrelationDatasets()
    this.getCorrelationSpaces()
  },
  mounted() {
    document.body.addEventListener("click", function (event) {
      var target = event.target || event.srcElement;
      if (target.nodeName.toLocaleLowerCase() === "a") {
        if (target.hash) {
          if (event.preventDefault) {
            event.preventDefault();
          } else {
            window.event.returnValue = true;
          }
          this.choosePush(target.hash); // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
        } else {
          if (target.indexOf("#") != -1) {
            this.choosePush(target);
          }
        }
      }
    }.bind(this)
    );
  },
  methods: {
    choosePush(target) {
      //console.log('555', target)
      let hash = target.substring(1);//去除#号
      if (hash == 'building-the-next-generation-of-open-source-and-bilingual-llms') {
        window.scrollTo(0, 0);
      } else {
        document.querySelector('[id*=' + hash + ']').scrollIntoView(true);
      }
    },
    // 关联模型列表
    getCorrelationModels() {
      this.correlationModels = []
      this.loading1 = true
      const data = {
        project_id: this.modelDetail.id,
        project_type: 'M'
      }
      this.$api.project
        .relatelist(data)
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.correlationModels = res.data.list
          }
        })
        .finally(() => {
          this.loading1 = false
        })
    },
    // 关联数据集列表
    getCorrelationDatasets() {
      this.correlationDatasets = []
      this.loading2 = true
      const data = {
        project_id: this.modelDetail.id,
        project_type: 'D'
      }
      this.$api.project
        .relatelist(data)
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.correlationDatasets = res.data.list
          }
        })
        .finally(() => {
          this.loading2 = false
        })
    },
    //关联体验
    getCorrelationSpaces() {
      let data = {
        project_model_id: this.modelDetail.id
      }
      this.$api.project
        .getModelRelateModelServings(data)
        .then((res) => {
          const { message } = res
          if (message === 'Success') {
            this.correlationSpaces = res.data
          }
        })
    },
    goModelDetail(data) {
      const { username_en, project_name_en } = data
      this.$router.push(`/models/${username_en}/${project_name_en}`)
    },
    goDatasetDetail(data) {
      const { username_en, project_name_en } = data
      this.$router.push(`/datasets/${username_en}/${project_name_en}`)
    },
    goSpacesDetail(data) {
      // const { username_en, serving_name_en } = data
      // this.$router.push({ path: `/spaces/${username_en}/${serving_name_en}` })   
      if(data.model_image_link===''){
        this.$router.push({ path: `/spaces/${data.userName}/${data.servingName}` });
      }else{
        window.open(data.model_image_link,'_blank')
      }
    },
    toMarkdown(content) {
      const res = marked(content)
      // 重新设置图片路径，解决图片404问题
      const markdownImgs = document.querySelectorAll('.markdown-body img')
      markdownImgs.forEach((i) => {
        // i.src = path.key.image + i.src
      })
      return res
    }
  }
}
</script>
<style lang="scss" scoped>

@import 'github-markdown-css/github-markdown-light.css';
.phoneshow{
  display: none;
}
.markdown-body ul {
  list-style: disc !important;
}

.page {
  min-height: calc(100vh - 310px);
}
@media only screen and (max-width: 768px) {
.pcshow{
  display: none;
}
.phoneshow{
  display: block;
}
}

</style>
